import React from 'react';
import ReactDOM from 'react-dom';
import './utils/replaceUrl';
import 'antd/dist/antd.less';
import { Provider } from 'react-redux';
import './assets/common.scss';
import store from './store/index';
import App from './App';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import reportWebVitals from './reportWebVitals';
import './fkexi';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('gwm-container')
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
